<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<!---------- Hero Banner Start ---------->
<div class="image-cover hero-banner" style="background:url(assets/img/a.jpg) no-repeat;">
    <div class="container">
        <app-property-search [homeFlag]="isHome"></app-property-search>
    </div>
</div>
<!-- Hero Banner End-->

<!---------- Three Logo Start ---------->
<section class="pb-0">
    <div class="container">
        <div class="row align-items-center blackandwhite">
            <div class="logo-sec-point mb-4 mb-md-0 text-center">
                <a href="https://www.bbb.org/us/mi/commerce-twp/profile/property-management/north-bloomfield-properties-0332-28004501/#sealclick" target="_blank" rel="nofollow"><img src="https://seal-easternmichigan.bbb.org/seals/black-seal-200-42-bbb-28004501.png" style="border: 0;" alt="North Bloomfield Properties BBB Business Review" ></a>
            </div>
            <div class="logo-sec-point mb-4 mb-md-0 text-center">
                <img src="../../../assets/img/footer-symbol-area-final.png" class="img-fluid" alt="North Bloomfield Properties" width="282" height="136" loading="lazy">
            </div>
            <div class="logo-sec-point text-center">
                <img src="../../../assets/img/2016_Visitors_Choice_100.png" class="img-fluid" alt="2016 APM Visitors' Award winner" width="100" height="100" loading="lazy">
            </div>
        </div>
    </div>
</section>
<!---------- Three Logo End ---------->


<!---------- Featured Listings Start ---------->
<section #featuredListSection>
    <div class="container">

        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="sec-heading2 center  mb-3">
                    <div class="sec-left">
                        <h3>Featured Listings</h3>
                        <p>
                            <!--Find new & featured property for you.-->
                        </p>
                    </div>
                    <div class="sec-right">
                        <a href="properties/FeaturedProperties">View All<i class="ti-angle-double-right ml-2"></i></a>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="property-slide">

                    <!-- Slides Iteration Start -->
                    <swiper [config]="config1" class="slide-full-width body-left pagination-dark">
                        <ng-container *ngFor="let property of properties">
                            Single Slide Start
                            <ng-template swiperSlide>
                                <app-property-card [data]="property"></app-property-card>
                            </ng-template>
                            Single Slide End
                        </ng-container>
                    </swiper>
                    <!-- Slides Iteration End -->
                </div>
            </div>
        </div>

    </div>
</section>
<!---------- Featured Listings End ---------->


<!---------- Counter Start ---------->
<section class="pt-0" inViewport (inViewportAction)="onIntersection($event)">
    <div class="counters">
        <div class="container">
            <div class="row">
                <div *ngFor="let acheivement of achievementsData; trackBy: achievementTrackByFn"
                    class="col-lg-3 col-md-6 col-sm-12">
                    <div class="media counter-box">
                        <div class="media-left">
                            <fa-icon *ngIf="acheivement.content !== 'Listings For Rent'" [icon]="['fas', acheivement.iconString]" class="theme-cl"></fa-icon>
                            <img src="../../../assets/img/rent.png" *ngIf="acheivement.content === 'Listings For Rent'" class="rent-icon">
                        </div>
                        <div class="media-body">
                            <h1 class="counter Starting" id="{{acheivement.title}}">0</h1>
                            <p>{{acheivement.content}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!---------- Counter End ---------->


<!---------- What are you looking Start ---------->
<section class="pt-0">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="sec-heading center">
                    <h2>WHAT ARE YOU LOOKING FOR?</h2>
                    <p>If you are looking for real estate services, you have come to the right place.
                        North
                        Bloomfield Properties provides services to home buyers, tenants, and real estate investors whether you're looking to rent, purchase or sell a property. Our property management tools make sure that you save time and get what you are looking for.
                    </p>
                </div>
            </div>
        </div>
        <div class="row align-items-center mobile-view-changes-one">
            <div class="col-lg-6 col-md-12">
                <img src="../../../assets/img/img-1.jpeg" class="img-fluid" alt="What you are looking for" height="540" width="540" style="margin: 0 auto;display: block;" loading="lazy">
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="icon-mi-left">
                    <fa-icon class="theme-cl" icon="home"></fa-icon>
                    <div class="icon-mi-left-content">
                        <h4>Single Family Homes</h4>
                        <!-- <p>A single-family home is the type of residential property connecting significantly with the
                            mainstream
                            idea of what a “home” looks like: a yard of your own, a roof.</p> -->
                    </div>
                </div>
                <div class="icon-mi-left">
                    <fa-icon class="theme-cl" icon="dungeon"></fa-icon>
                    <div class="icon-mi-left-content">
                        <h4>Condos</h4>
                        <!-- <p>If you are looking for the ultimate urban green living, you can consider a high-rise condo.
                            Condos
                            make it possible to enjoy green living in the core of the city.</p> -->
                    </div>
                </div>
                <div class="icon-mi-left">
                    <fa-icon class="theme-cl" icon="synagogue"></fa-icon>
                    <div class="icon-mi-left-content">
                        <h4>Multi Family Homes</h4>
                        <!-- <p>Multi family homes offer more units to work and help you take on a larger pool of tenants.
                            This also
                            makes it easier to earn your investment back faster.</p> -->
                    </div>
                </div>
                <div class="icon-mi-left">
                    <fa-icon class="theme-cl" icon="building"></fa-icon>
                    <div class="icon-mi-left-content">
                        <h4>Apartments</h4>
                        <!-- <p>Apartment living is more cost effective for both bills and rent. Apartments are also quite a
                            sustainable option with a property manager assigned.</p> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!---------- What are you looking End ---------->


<!---------- North Bloomfield Properties Michigan’s Start ---------->
<section class="pt-0">
    <div class="container">
        <div class="sec-heading2 center  mb-3">
            <div class="sec-center" style="text-align:center;width:100%;">
                <h1 style="color: #000;font-weight:600;" class="h2">North Bloomfield Properties Michigan’s Premier
                    Property Management Company</h1>
            </div>
        </div>
        <!-- row Start -->
        <div class="row align-items-center" style="margin-top: 40px;">
            <div class="col-lg-3 col-md-3 text-center mb-4 mb-md-0 ">
                <a href="https://www.bbb.org/us/mi/commerce-twp/profile/property-management/north-bloomfield-properties-0332-28004501/#sealclick" target="_blank" rel="nofollow"><img src="https://seal-easternmichigan.bbb.org/seals/black-seal-200-42-bbb-28004501.png" style="border: 0;" alt="North Bloomfield Properties BBB Business Review" ></a>
            </div>
            <div class="col-lg-9 col-md-9">
                <div class="story-wrap explore-content">
                    <p>Since 1989, North Bloomfield Properties has been a leader in residential property management
                        throughout
                        southeast Michigan. With an A+ rating with the Better Business Bureau, 30+ years in business,
                        and the
                        experience of managing thousands and thousands of homes, we are the right choice for all of your
                        property management needs. Whether you are looking to lease a home for yourself or your family
                        or are
                        interested in having your property managed by a professional firm, please call or stop by one of
                        our
                        offices to see how we can help you
                        <!-- <a class="menu__link" (click)="readMoreFeatures()">{{featureReadMore ? 'Read Less...' :
                            'Read
                            More...'}}</a> -->
                    </p>
                </div>
            </div>
        </div>

        <div *ngIf="featureReadMore" class="row align-items-center" style="margin-top: 50px;">
            <div class="col-lg-4 col-md-4" *ngFor="let feature of features;trackBy: featureTrackByFn">
                <app-info-card [image]="feature.image" [title]="feature.title" [content]="feature.content">
                </app-info-card>
            </div>
        </div>
    </div>
</section>
<!---------- North Bloomfield Properties Michigan’s End ---------->


<!---------- We are your neighbors Start ---------->
<section class="pt-0">
    <div class="container">
        <div class="row align-items-center mobile-view-changes-two">
            <div class="col-lg-6 col-md-6">
                <ng-template ngFor let-feature [ngForOf]="features" [ngForTrackBy]="featureTrackByFn">
                    <app-info-list-tile [leadingImage]="feature.image" [title]="feature.title"
                        [content]="feature.content" [link]="feature.link">
                    </app-info-list-tile>
                </ng-template>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="story-wrap explore-content" style="padding-top:20px;">
                    <p>We are your neighbors. North Bloomfield Properties has always been locally owned and operated.
                        Our
                        experienced and knowledgeable staff can assist you in all aspects of property management in
                        southeastern
                        Michigan. We take care of every aspect of property management for you, including:</p>
                    <ul class="content-list">
                        <li>Extensive marketing and advertising</li>
                        <li>Complete tenant screening</li>
                        <li>24-hour maintenance</li>
                        <li>Rent collection</li>
                        <li>Legal and accounting services</li>
                        <li>Real estate sales</li>
                        <li>and much more.</li>
                    </ul>
                    <p style="margin-bottom:0px;">For over thirty years, we have continued to build our
                        excellent
                        reputation through consistent and honest dealings. Our integrity and sincerity along with our
                        devotion
                        to skillful and competent service is what truly sets us apart from the rest.</p>
                </div>
            </div>
        </div>
    </div>
</section>
<!---------- We are your neighbors End ---------->


<!---------- Testimonials Start ---------->
<section class="image-cover" style="background:url(assets/img/Location-DETROIT-Topper.jpg);padding-bottom:0;"
    data-overlay="5">
    <div class="sec-heading2 center  mb-3">
        <div class="sec-center mobile-padding-title" style="text-align:center;width:100%;">
            <h2 style="color:#fff;">Testimonials</h2>
            <p style="color:#fff;">latest testimonials for North Bloomfield Properties.</p>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 testimonialmain" style="margin: 0 auto; width: 100%;padding: 16px 32px;">
            <div class="home-slider-container" style="max-width: initial; padding: 0;">
                <div class="testimonials-slide">
                    <!-- Slides Iteration Start -->
                    <swiper [config]="config2">
                        <ng-container *ngFor="let testimony of testimonials">
                            <!-- Single Slide Start -->
                            <ng-template swiperSlide>
                                <div class="single-items">
                                    <div class="testimonials-text visible" style="margin: 0 auto;">
                                        <h3>By {{testimony?.title}}</h3>
                                        <p>{{testimony?.content}}</p>
                                    </div>
                                </div>
                            </ng-template>
                            <!-- Single Slide End -->
                        </ng-container>
                    </swiper>
                    <!-- Slides Iteration End -->
                </div>
            </div>
        </div>
    </div>
</section>
<!---------- Testimonials Start ---------->


<!---------- Find Properties By Cities Start ---------->
<section>
    <app-city-finder [data]="propertyByCities"></app-city-finder>
</section>
<router-outlet></router-outlet>
<!---------- Find Properties By Cities End ---------->
